<template>
  <div class="mod-wf-condition-field">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="search">
      <el-form-item label="单据类型">
        <el-select v-model="dataForm.bizType" clearable size="small" style="width:150px">
          <el-option v-for="o in bizTypeOptions" :key="o.value" :label="o.label" :value="o.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="字段键">
        <el-input v-model="dataForm.fieldKey" size="small" clearable style="width:130px" />
      </el-form-item>
      <el-form-item label="显示名称">
        <el-input v-model="dataForm.fieldLabel" size="small" clearable style="width:130px" />
      </el-form-item>
      <el-form-item label="启用">
        <el-select v-model="dataForm.enabled" clearable size="small" style="width:90px">
          <el-option label="是" value="1" />
          <el-option label="否" value="0" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('workflow:conditionField:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('workflow:conditionField:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <div class="hint">字段键须与代码中审批上下文 buildContext 的键一致，否则条件无法匹配。</div>
    <el-table :data="pageRows" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" :index="indexMethod" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="bizType" label="单据类型" width="130" header-align="center" align="left">
        <template slot-scope="s">{{ bizTypeLabel(s.row.bizType) }}</template>
      </el-table-column>
      <el-table-column prop="fieldKey" label="字段键" min-width="120" header-align="center" align="left">
        <template slot-scope="s">
          <a v-if="isAuth('workflow:conditionField:info')" class="code-link" @click="open(s.row.fieldId, true)">{{ s.row.fieldKey }}</a>
          <span v-else>{{ s.row.fieldKey }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fieldLabel" label="显示名称" min-width="120" header-align="center" align="left" />
      <el-table-column prop="valueType" label="值类型" width="90" header-align="center" align="left">
        <template slot-scope="s">{{ valueTypeLabel(s.row.valueType) }}</template>
      </el-table-column>
      <el-table-column prop="lineSort" label="排序" width="70" header-align="center" align="center" />
      <el-table-column prop="remark" label="备注" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="enabled" label="启用" width="70" header-align="center" align="center">
        <template slot-scope="s">
          <el-tag :type="s.row.enabled === '1' ? 'success' : 'info'" size="mini">{{ s.row.enabled === '1' ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="v => { pageIndex = v }"
      @size-change="v => { pageSize = v; pageIndex = 1 }"
      :current-page="pageIndex" :page-size="pageSize" :total="filtered.length"
      layout="total, sizes, prev, pager, next" style="margin-top:12px" />
    <field-dialog v-if="visible" ref="dlg" :biz-type-options="bizTypeOptions" @refreshDataList="load" />
  </div>
</template>

<script>
import request from '../../api/request'
import auth from './workflowAuth'
import FieldDialog from './ConditionFieldDialog.vue'

const VALUE_TYPES = [
  { value: 'number', label: '数字' },
  { value: 'dept', label: '部门' },
  { value: 'user', label: '用户' },
  { value: 'text', label: '文本' },
  { value: 'string', label: '文本' }
]

export default {
  name: 'WorkflowConditionField',
  mixins: [auth],
  components: { FieldDialog },
  data() {
    return {
      dataForm: { bizType: '', fieldKey: '', fieldLabel: '', enabled: '' },
      bizTypeOptions: [],
      all: [],
      loading: false,
      pageIndex: 1,
      pageSize: 20,
      visible: false
    }
  },
  computed: {
    filtered() {
      const q = this.dataForm
      return this.all.filter(row => {
        if (q.bizType && row.bizType !== q.bizType) return false
        if (q.fieldKey && String(row.fieldKey || '').indexOf(q.fieldKey) < 0) return false
        if (q.fieldLabel && String(row.fieldLabel || '').indexOf(q.fieldLabel) < 0) return false
        if (q.enabled && String(row.enabled) !== q.enabled) return false
        return true
      })
    },
    pageRows() {
      const start = (this.pageIndex - 1) * this.pageSize
      return this.filtered.slice(start, start + this.pageSize)
    }
  },
  created() { this.loadBizTypes(); this.load() },
  activated() { this.loadBizTypes(); this.load() },
  methods: {
    loadBizTypes() {
      request.get('/workflow/definition/bizTypes').then(res => {
        this.bizTypeOptions = (res.data || []).map(item => ({ value: item.docType, label: item.docName }))
      }).catch(() => {})
    },
    bizTypeLabel(value) {
      const hit = this.bizTypeOptions.find(o => o.value === value)
      return hit ? hit.label : value
    },
    valueTypeLabel(value) {
      const hit = VALUE_TYPES.find(o => o.value === value)
      return hit ? hit.label : value
    },
    indexMethod(index) { return (this.pageIndex - 1) * this.pageSize + index + 1 },
    search() { this.pageIndex = 1 },
    load() {
      this.loading = true
      request.get('/workflow/conditionField/list').then(res => { this.all = res.data || [] }).catch(() => { this.all = [] }).finally(() => { this.loading = false })
    },
    open(id, readonly) {
      this.visible = true
      this.$nextTick(() => this.$refs.dlg.init(id, readonly))
    }
  }
}
</script>

<style scoped>
.hint { color: #909399; font-size: 12px; margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
</style>
